import React from "react";
import { Box, Skeleton, Stack, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

const EnhanceYourTourCardSkeleton = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      height: { xs: "68rem", sm: "66rem", md: "76rem" },
      width: { xs: "32rem", sm: "34rem", md: "61rem" },
      flexShrink: 0
    }}
  >
    {/* Image Skeleton */}
    <Skeleton
      variant="rectangular"
      sx={{
        borderRadius: "2rem 2rem 0 0",
        width: "100%",
        height: { xs: "21.2rem", md: "37rem" },
        flexShrink: 0
      }}
    />

    {/* Content Skeleton */}
    <Stack
      sx={{
        backgroundColor: "grey.100",
        borderRadius: "0rem 0rem 2rem 2rem",
        padding: { xs: "3.2rem 2.4rem", md: "3.2rem" },
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "2.4rem"
      }}
    >
      {/* Content */}
      <Stack sx={{ gap: "2.4rem" }}>
        {/* Title and Chip */}
        <Stack sx={{ gap: "1.2rem" }}>
          <Skeleton variant="text" width="80%" height={28} />
          <Skeleton
            variant="rounded"
            width="14rem"
            height="3.2rem"
            sx={{ borderRadius: "1rem" }}
          />
        </Stack>

        {/* Activity Level and Extension Style */}
        <Stack sx={{ gap: "1.2rem" }}>
          <Stack sx={{ gap: "1.6rem" }}>
            <Skeleton variant="text" width="70%" height={24} />
            <Skeleton variant="text" width="60%" height={24} />
          </Stack>

          {/* Description Lines */}
          <Stack sx={{ gap: "0.8rem" }}>
            <Skeleton variant="text" width="100%" height={20} />
            <Skeleton variant="text" width="100%" height={20} />
            <Skeleton variant="text" width="75%" height={20} />
          </Stack>
        </Stack>
      </Stack>

      {/* Button Skeleton */}
      <Skeleton
        variant="rounded"
        sx={{
          width: { xs: "100%", md: "fit-content" },
          minWidth: { md: "15rem" },
          height: "4.8rem",
          borderRadius: "10rem"
        }}
      />
    </Stack>
  </Box>
);

const EnhanceYourTourSkeleton = () => {
  const t = useTranslations("PDP");
  
  return (
    <Box className="fluid-box" component="section">
    <Box
      className="destination-page-container"
      sx={{
        padding: {
          xs: "4rem 2.4rem",
          sm: "4rem 2.4rem",
          md: "6rem clamp(2.4rem, 4.5vw, 6.5rem)"
        },
        display: "flex",
        flexDirection: "column",
        gap: { xs: "2.4rem", sm: "4rem" }
      }}
    >
      <Typography variant="h2" color="primary.main">
        {t("Enhance Your Tour")}
      </Typography>
      <Stack
        direction="row"
        sx={{
          gap: "2.4rem",
          overflow: "hidden",
          justifyContent: "flex-start"
        }}
      >
        <EnhanceYourTourCardSkeleton />
        <EnhanceYourTourCardSkeleton />
      </Stack>
    </Box>
  </Box>
  );
};

export default EnhanceYourTourSkeleton;
